import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { label: "影视作品", to: "/works" },
      { label: "明星资讯", to: "/stars" },
      { label: "影视动态", to: "/news" },
    ],
  },
  {
    title: "关于品牌",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "首页", to: "/" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100 md:mt-24">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-black text-foreground-950">
                朝
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-background-50">朝桐光</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              朝桐光官方影视门户，专注影视作品展示、明星资讯与行业动态，为影迷提供权威、丰富、可信赖的影视内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-youtube-line", label: "YouTube" },
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-900 text-lg text-background-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={s.icon}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 朝桐光 版权所有 · 本站内容为品牌展示用途</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>京ICP备 0000000 号</span>
            <span>影视资讯 · 作品展示 · 明星动态</span>
          </p>
        </div>
      </div>
    </footer>
  );
}